import cx from 'classnames';
import { useContext } from 'react';
import ModalContext from '~/context/home/ModalContext';

export default function BackgroundOverlay() {
  const { isSearchBarFocused } = useContext(ModalContext);

  return (
    <div
      aria-hidden="true"
      className={cx(
        'pointer-events-none fixed left-0 top-0 z-20 h-dvh w-full bg-canvas-overlay transition-all duration-300',
        isSearchBarFocused ? 'opacity-100' : 'opacity-0'
      )}
    />
  );
}
